<template>
  <div :style="'padding: 0 20px; --cor-primaria:' + corPrimaria + '0A'" class="especialidades-wrapper">
    <el-input v-if="lista" v-model="search" type="text" prefix-icon="el-icon-search" placeholder="Pesquisar especialidade..." clearable></el-input>
    <span class="title">{{textoPesquisaEspecialidade}}</span>
    <div v-if="lista">
      <listagem v-if="listaFiltrada.length" :click-row="selectEspecialidade" :listagem-data="listaFiltrada" :columns="columns" :icone="'Arrow_chevron'"></listagem>
      <div v-else-if="search && search.length > 0">
        <el-alert :closable="false" type="warning" show-icon>Nenhuma especialidade encontrada com o termo pesquisado.</el-alert>
      </div>
      <dialog-default
        v-if="alerta"
        :show-close="false"
        custom-class="dialog-especialidades"
        :title="alerta.descricao"
        :open.sync="dialogVisible"
        width="47%"
      >
        <span>{{alerta.alerta}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="btn-dialog" :style="`background-color: ${corBotaoSecundario}`" @click="nextStep">
            <span :style="`color: ${corTextoBotaoSecundario}`">Entendi</span>
          </el-button>
          </span>
      </dialog-default>
    </div>
    <ErrorVazio v-else :show-btn="false"/>
  </div>
</template>
<script>
import Listagem from '@/components/Listagem/Listagem'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ArrowButton from '@/components/listagemColumn/ArrowButton'
import DialogDefault from '@/components/DialogDefault/DialogDefault.vue'
import ErrorVazio from '@/components/Error/ErrorVazio'

export default {
  data () {
    return {
      lista: null,
      listaFiltrada: null,
      columns: [{ field: 'descricao', width: '490px' }, { field: '', component: ArrowButton }],
      alerta: null,
      dialogVisible: false,
      nome: '',
      search: null
    }
  },
  components: { DialogDefault, Listagem, ErrorVazio },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapState('Func53', ['paciente', 'idLocal', 'idAgenda']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapGetters('Func53', ['tipoServico']),
    textoPesquisaEspecialidade () {
      return this.funcionalidade.parametros.textos.textoPesquisaEspecialidade
    },
    textoBotaoSelecaoEspecialidade () {
      return this.funcionalidade.parametros.textos.textoBotaoSelecaoEspecialidade
    },
    textoBotaoSelecaoProfissional () {
      return this.funcionalidade.parametros.textos.textoBotaoSelecaoProfissional
    },
    ativaBuscaProfissionais () {
      return this.funcionalidade.parametros.ativaBuscaProfissionais
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoSecundario () {
      return this.estilo.botaoSecundario.corBotaoSecundario
    },
    corTextoBotaoSecundario () {
      return this.estilo.botaoSecundario.corTextoBotaoSecundario
    }
  },
  watch: {
    search (term) {
      if (!term) {
        this.listaFiltrada = this.lista
      } else {
        const keyword = this.normalize(term)
        this.listaFiltrada = this.lista.filter((item) => this.normalize(item.descricao).includes(keyword))
      }
    }
  },
  methods: {
    ...mapActions('Func53', ['setIdEpecialidade', 'setEspecialidadeDescricao', 'setTipoServico', 'setIdServico']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    ...mapMutations('BreadCrumbsStore', ['SET_CURRENT_STEP']),
    async init () {
      const payload = {
        tipoAgenda: this.idAgenda,
        paciente: this.paciente
      }
      if (this.idLocal) payload.idLocal = this.idLocal
      const res = await this.apiFuncionalidade.listaEspecialidades({
        payload,
        loading: true
      })
      this.lista = res.data.especialidades
      this.listaFiltrada = this.lista
    },
    selectEspecialidade (row) {
      this.nome = row.nome
      if (row.alerta) {
        this.alerta = row
      }

      let value
      this.ordem === 2 ? value = 3 : value = 2

      let step
      this.idAgenda === '2' ? step = 3 : step = value
      const data = { step: step, value: row.descricao }
      this.updateIten(data)

      this.setIdEpecialidade(row.id)
      this.setEspecialidadeDescricao(row.descricao)
      if (row.tipoServico) {
        this.setTipoServico(row.tipoServico)
      }
      if (this.alerta) {
        this.dialogVisible = true
      } else {
        this.nextStep()
      }
    },
    nextStep () {
      if (this.dialogVisible) {
        this.dialogVisible = false
      }
      if (this.$route.query.step === '4') {
        if (this.tipoServico && this.tipoServico.length > 0) {
          return this.$router.replace({ query: { step: '4.1' } })
        }
        return this.$router.replace({ query: { step: 5 } })
      }
      if (this.tipoServico && this.tipoServico.length > 0) {
        return this.$router.replace({ query: { step: '3.1' } })
      }
      return this.$router.replace({ query: { step: 4 } })
    },
    resetTipoServico () {
      this.setTipoServico([])
      this.setIdServico(null)
    },
    normalize (text) {
      if (!text) return text

      return text
        .normalize('NFD') // separa acentos
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .toLowerCase() // ignora case
    }
  },
  async created () {
    this.SET_CURRENT_STEP(2)
    this.resetTipoServico()
    await this.init()
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@200&family=Open+Sans:wght@300&display=swap');
.title {
  font-family: 'Open Sans', sans-serif;
  margin: 0!important;
  padding: 0!important;
}
.especialidades-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>
